import styled from 'styled-components';

export const StyledTileBody = styled.ul`
  height: 290px;
  padding-left: 0;
  margin-top: 5px;
  margin-bottom: 0;
  overflow-x: hidden;
  ${({ theme }) => theme.scrollbar};
`;

export const StyledTileItem = styled.li`
  margin-bottom: 10px;
`;

export const StyledLabel = styled.label`
  color: ${({ color }) => color};
  background-color: ${({ backColor }) => backColor};

  margin: 0 10px;
  font-size: 12px;
  line-height: 18px;
  font-style: normal;
  font-weight: normal;

  &:last-child {
  }

  :not(:first-of-type) {
    margin-left: auto;
  }
`;

export const StyledTopOrderItem = styled.div`
  display: flex;
  justify-content: space-between;
`;
